import {Base} from './Base'

export class Option extends Base {

  resourceName() {
    return 'options'
  }

  fields() {
    return [
      'name',
      'sort',
      'is_deleted',
    ]
  }

}